import React from "react";
import "../../../styles/TablesSBoardType1.css";

type RenderTableProps = {
  table: string[][];
};

const RenderTable: React.FC<RenderTableProps> = ({ table }) => {
  const rowsCount = table.length;
  const columnsCount = table[0].length;
  const numberHeader = Array.from({ length: columnsCount }, (_, i) => i + 1);

  const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ".split("");
  const symbolHeader = alphabet.slice(0, rowsCount);
  const compact = rowsCount > 5;

  return (
    <div
      className={`tableS-table--Type1 ${compact ? "tableS-table--compact--Type1" : ""}`}
      style={
        {
          "--column-count": columnsCount,
        } as React.CSSProperties
      }
    >
      {/* левый верхний угол */}
      <div className="tableS-header--Type1" />

      {/* номера столбцов */}
      {numberHeader.map((column) => (
        <div
          key={column}
          className={`tableS-header--Type1 ${
            compact ? "tableS-header--small--Type1" : ""
          }`}
        >
          {column}
        </div>
      ))}

      {table.map((row, rowIndex) => (
        <React.Fragment key={rowIndex}>
          <div
            className={`tableS-header--Type1 ${
              compact ? "tableS-header--small--Type1" : ""
            }`}
          >
            {symbolHeader[rowIndex]}
          </div>

          {row.map((cell, columnIndex) => (
            <div
              key={columnIndex}
              className={`tableS-cell--Type1 ${
                compact ? "tableS-cell--small--Type1" : ""
              }`}
            >
              {cell}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default RenderTable;
